export class Percentages {   
    first: number;
    second: number;
    third: number
    
    constructor(first: number, second: number, third: number) {
        this.first = first;
        this.second = second;
        this.third = third;
    }
}


// WEBPACK FOOTER //
// ./src/app/views/campaign/new-campaign/step-3/triple-percentage-slider/percentages.model.ts